export const DEFAULT_ATTACHMENT_PREVIEW_SIZE = 320;
export const MIN_ATTACHMENT_PREVIEW_SIZE = 160;
export const MAX_ATTACHMENT_PREVIEW_SIZE = 800;

export function attachmentPreviewSize(value: unknown): number {
  return typeof value === 'number' && Number.isInteger(value)
    && value >= MIN_ATTACHMENT_PREVIEW_SIZE && value <= MAX_ATTACHMENT_PREVIEW_SIZE
    ? value : DEFAULT_ATTACHMENT_PREVIEW_SIZE;
}
